import { useCallback } from "react"
import { useRelayEnvironment } from "react-relay"
import { fetchQuery, graphql } from "relay-runtime"
import { useTreatmentPlanForPreventionProgramsQuery as TreatmentPlanForPreventionProgramsQueryType } from "@/modules/patients/services/__generated__/useTreatmentPlanForPreventionProgramsQuery.graphql"

export const treatmentPlanForPreventionProgramsQuery = graphql`
  query useTreatmentPlanForPreventionProgramsQuery($id: ID!) {
    treatmentPlanTemplateById(id: $id) {
      id
      isDraft
      languages {
        language
        title
        recommendedTreatment
        followUpInstructions
      }
    }
  }
`

export function useTreatmentPlanForPreventionProgramsQuery() {
  const environment = useRelayEnvironment()

  return useCallback(
    (id: string) =>
      fetchQuery<TreatmentPlanForPreventionProgramsQueryType>(environment, treatmentPlanForPreventionProgramsQuery, {
        id,
      }).toPromise(),
    [environment],
  )
}
